import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface CheckDrugProps extends CacheProps {
  data: Array<any>
}

const checkDrugApi = ({ data, ...rest }: CheckDrugProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.pharmacies.check-drug'],
    payload: {
      data: data,
    },
    withToken: true,
    ...rest,
  });
};

export default checkDrugApi;
